import React, { Suspense } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { DrawerMenu } from 'components/fragment';

const MainLayout = () => {
  const location = useLocation();
  return (
    <React.Fragment>
      <Suspense fallback={<div>loading...</div>}>
        <DrawerMenu />
        <Outlet key={location.key} />
      </Suspense>
    </React.Fragment>
  );
};

export default MainLayout;
